import script from "./RichEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./RichEditor.vue?vue&type=script&setup=true&lang=js"

import "./RichEditor.vue?vue&type=style&index=0&id=20e329a3&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20e329a3"]])

export default __exports__